import React from 'react';
import AboutV1 from '../../components/about/AboutV1';
import FactV1 from '../../components/fact/FactV1';
import FeatureV1 from '../../components/feature/FeatureV1';
import CallToActionV1 from '../../components/callToAction/CallToActionV1';
import EventV2 from '../../components/Event/EventV2';
import FooterV1 from '../../components/footer/FooterV1';
import { Button } from '@mui/material';

const AboutUs = () => {
    return (
        <>
            <div className="page-wrapper" style={{
                marginTop:'150px',maxWidth:'1200px',marginLeft:'auto',marginRight:'auto',marginBottom:'50px'
            }}>
                <h2 style={{color:'#9B1321'}}>Terms and Conditions Policy</h2>
                <div>
  

  <p style={{color:"#000",marginTop:'10px'}}>
    <b style={{color:"#000"}}>(Conference Delegates – Bookings Made Through the Organizer)</b>
  </p>

  <p>
    To ensure proper coordination with partner hotels and to secure room
    allocations for conference delegates, all hotel accommodation bookings made
    through the conference organizer are subject to the following cancellation
    terms. Any refund, if applicable, will be calculated as a percentage of the
    total accommodation cost.<br></br>
  </p>

  <p style={{color:"#000",marginTop:'10px'}}>
    <b style={{color:"#000",marginTop:'10px'}}>Cancellation Policy by Timeframe</b>
  </p>

  <table
    style={{
      borderCollapse: "collapse",
      width: "100%",
    }}
    border="1"
    cellPadding="8"
    cellSpacing="0"
  >
    <thead>
      <tr>
        <th>Period Prior to Hotel Check-in Date</th>
        <th>Cancellation Charge</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>More than 90 days prior to check-in</td>
        <td>50% refund of the total accommodation cost</td>
      </tr>
      <tr>
        <td>60–89 days prior to check-in</td>
        <td>30% refund of the total accommodation cost</td>
      </tr>
      <tr>
        <td>30–59 days prior to check-in</td>
        <td>No refund</td>
      </tr>
      <tr>
        <td>Less than 30 days prior to check-in</td>
        <td>No refund</td>
      </tr>
      <tr>
        <td>No-Show</td>
        <td>100% charge of the total accommodation cost</td>
      </tr>
    </tbody>
  </table>

  <p style={{color:"#000",marginTop:'10px'}}>
    <b>General Terms &amp; Conditions</b>
  </p>

  <p>
    All hotel cancellation requests must be submitted in writing via the
    official conference email.
  </p>

  <p>
    The date of receipt of the written cancellation by the conference organizer
    will be considered the official cancellation date.
  </p>

  <p>
    Any bank charges, transaction fees, or transfer costs shall be borne by the
    guest.
  </p>

  <p>
    Room bookings are subject to hotel availability and hotel-specific
    policies, which may apply in addition to this policy.
  </p>

  <p>
    Room reservations are non-transferable unless approved in writing by the
    conference organizer.
  </p>

  <p>
    Early check-out, late arrival, or partial stay reductions are considered
    cancellations and are subject to the same policy.
  </p>

  <p style={{color:"#000",marginTop:'10px'}}>
    <b>Important Notice</b>
  </p>

  <p>
    By confirming the hotel booking and completing the payment, the guest
    acknowledges and agrees to the Hotel Accommodation Cancellation &amp;
    No-Show Policy stated above, without exception.
  </p>
</div>
                
              
               
            </div>
            
        </>
    );
};

export default AboutUs;